import { Dot, EyeSlash, ThreeDotsVertical, Trash } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { Dropdown, MenuProps, Space, Typography } from 'antd';

import ImageRatio from '@/components/shared/ImageRatio';
import { getCdnUrl } from '@/helpers';
import { formatMonthAndDay } from '@/helpers/formatDate';
import { IUserNotification } from '@/interfaces/notification';
import { useDeleteNotificationMutation, useToggleNotificationMutation } from '@/services/notifications';
import styled, { css, StyledProp } from '@/styled';

const Item = (props: IUserNotification & StyledProp) => {
  const navigate = useNavigate();
  const [deleteNotification] = useDeleteNotificationMutation();
  const [toggleNotification] = useToggleNotificationMutation();

  const dropdownItems: MenuProps['items'] = [
    {
      icon: <Trash />,
      key: 0,
      label: <Typography.Link onClick={() => deleteNotification(props.id)}>Excluir</Typography.Link>
    },
    {
      icon: <EyeSlash />,
      key: 1,
      label: (
        <Typography.Link onClick={() => toggleNotification({ id: props.id, read: !props.read })}>
          Marcar como lido
        </Typography.Link>
      )
    }
  ];

  const goToNotificationTarget = () => {
    navigate(`/curso/${props?.link?.split('curso/')[1]}`);
  };

  return (
    <div className={props.className}>
      <ImageRatio
        className='image'
        aspect='16:9'
        src={getCdnUrl(props?.new_cover_url)}
        alt='imagem da notificação'
        onClick={goToNotificationTarget}
      />
      <Space size={0} rootClassName='content' direction='vertical'>
        <Typography.Text ellipsis onClick={goToNotificationTarget}>
          {props?.description}
        </Typography.Text>
        <Typography.Text ellipsis onClick={goToNotificationTarget}>
          {props?.title}
        </Typography.Text>
        <Typography.Text ellipsis onClick={goToNotificationTarget} className='courseTitle'>
          {props?.course_title}
        </Typography.Text>
      </Space>
      <div className='sideContent'>
        <Typography.Text>{formatMonthAndDay(props.created_at)}</Typography.Text>
        <Dot className='dot' data-read={props.read} />
        <Dropdown menu={{ items: dropdownItems }}>
          <ThreeDotsVertical />
        </Dropdown>
      </div>
    </div>
  );
};

export default styled(Item)(({ theme }) => {
  return css`
    display: grid;
    align-self: center;
    justify-content: center;
    width: 100%;
    padding: ${theme.space.spacing(3, 6)};
    grid-gap: ${theme.space.pxToRem(8)};
    grid-template-columns: 130px 227px auto;
    border-bottom: 1px solid ${theme.variables.borderColor};

    .dot {
      color: ${theme.colorPrimary};

      &[data-read='true'] {
        color: transparent;
      }
    }

    ${theme.breakpoints.down('md')} {
      grid-template-columns: 80% 20%;

      .image {
        display: none;
      }
    }

    .ant-typography {
      height: 24px;
    }

    .courseTitle {
      color: ${theme.colorTextTertiary};
    }

    .sideContent {
      display: grid;
      grid-template-rows: 24px auto 24px;
      justify-items: flex-end;
    }

    .content {
      .ant-typography {
        cursor: pointer;
      }
    }
  `;
});
